import { useContext } from "react";
import { GlobalContextType, GlobalContext } from "./GlobalContextProvider";

export function useMarketContext() {
  const { tccMarkets } = useContext<GlobalContextType>(GlobalContext);
  return tccMarkets;
}
